import Constant from '@/common/constant/Constant';
import { BASIC_SETTING, ADVANCED_SETTING } from '@/common/constant/ModuleSettingVersionConstant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import Utils from '@/common/utils/utils';
import I18n from '@/rI18n';
import { getDetailByProductId, getProductById, updateProductManagement } from '@/service/productManagementService';
import _ from 'lodash';
import { getPublicAPI } from '@/service/publicService';
import { getTicketById } from '@/service/ticketService';

export const invalidCharsLimitValue = ['.', '-', '+', 'e', 'E', ',', '/'];
export const specialCharacters = ['!','@','#','$','%','^','&','*','(',')','_','-','+','[',']','{','}',':',';','"',"'",'|','\\','/','<','>','?',',','.'
];
export const validCharacters = ['0','1','2','3','4','5','6','7','8','9','.'
];
export const validKeydownCharacters = ['0','1','2','3','4','5','6','7','8','9','.','Backspace','ArrowUp','ArrowDown','ArrowLeft','ArrowRight', 'Control', 'v'
];

export const filterLabelByKey = key => {
    const constants = {
        internalQACounterSettings: '問い合わせ窓口設置',
        externalServiceDeskSettings: '組織外向けサービスデスク機能',
        deskService: '公開サービスデスクプロジェクト設置',
        publicWebForm: '公開Webフォーム',
        emailResponseFunction: 'メール対応機能',
        knowledgeFunction: 'ナレッジ機能',
        knowledgeService: 'SolutionDeskでのナレッジ利用',
        publicService: '公開ナレッジ',
        knowledgeBot: 'ナレッジロボ',
        synonymSearch: '類義語検索',
        convertPDF: 'PDF検索',
        batchCommandService: '一括コマンド',
        chatAI: 'AI',
        lincenseKeyPermission: '貸出ライセンスキー利用を許可する',
        aiAuto: 'AIオート',

        taskManagement: '課題管理機能',
        advancedOptionSettings: '拡張オプション',
        logAnalysis: '分析',
        ipRestriction: 'IPアドレス制限',

        numberOfTickets: 'チケット数',
        numberOfKnowledges: 'ナレッジ数',
        numberOfFormat: 'フォーマット数',
        numberOfQACounters: '問い合わせ窓口数',
        numberOfSupportedCounters: 'サポート窓口数',
        numberOfGeneralProjects: 'プロジェクト数',
        numberOfInternalCustomers: '組織内カスタマーID数',
        numberOfB2C: '個人カスタマーID数',
        storageVolume: 'ストレージ容量',
        generalUserFee: '一般ユーザーID料金',
        basicCharge: '基本料金',

        numberOfAdditionalTickets: 'チケット数追加',
        numberOfAdditionalKnowledge: 'ナレッジ数追加',
        numberOfAdditionalStorages: 'ストレージ追加',
        numberOfAdditionalQACounter: '問い合わせ窓口数追加',
        numberOfAdditionalSupportedCounter: 'サポート窓口数追加'
    };

    const foundEntry = Object.entries(constants).find(([k, v]) => k === key);

    if (foundEntry) {
        return foundEntry[1];
    } else {
        return '';
    }
};

export const filterUnitByKey = key => {
    const constants = {
        quantity: '個',
        storage: 'Gb',
        price: '円',
        setPersion: '個/人',
        setCorp: '個/組織',
        setCorpPersion: '人/組織',
        gbPersion: 'Gb/人'
    };

    const foundEntry = Object.entries(constants).find(([k, v]) => k === key);

    if (foundEntry) {
        return foundEntry[1];
    } else {
        return '';
    }
};

export const renderUnitAdvancedByKeyAndType = ( key, type ) => {
    if (key === 'quantity' && type === 'number') return '個';
    if (key === 'quantity' && type === 'decimal') return 'Gb';
    if (key === 'price' && type === 'number') return '円';
    return '';
};

export const handleValidateAdvancedSettingOption = (
    edittingKey,
    edittingKeyOfValue,
    otherKey,
    otherKeyOfValue,
    field,
    setValue,
    errorEditingKey,
    errorOtherKey
) => {
    let errors = {
        [edittingKey]: errorEditingKey,
        [otherKey]: errorOtherKey
    };

    if (edittingKeyOfValue.length === 0) {
        if (otherKeyOfValue.length > 0) {
            errors[edittingKey] = I18n.get('COMMSG014');
        } else {
            errors[otherKey] = '';
        }
    } else if (otherKeyOfValue.length === 0) {
        errors[otherKey] = I18n.get('COMMSG014');
    }

    setValue(prev => ({
        ...prev,
        [field]: {
            ...prev[field],
            [edittingKey]: {
                ...prev[field][edittingKey],
                error: errors[edittingKey]
            },
            [otherKey]: {
                ...prev[field][otherKey],
                error: errors[otherKey]
            }
        }
    }));
};

export const isValidInput = (inputValue, validCharacterArray) => {
    for (let i = 0; i < inputValue.length; i++) {
        const char = inputValue[i];
        if (!validCharacterArray.includes(char)) {
            return false;
        }
    }
    return true;
};

export const checkValueOfVersionName = versionName => {
    if (Utils.isEmptyString(versionName.value) || !Utils.isEmptyString(versionName.error)) {
        return false;
    }
    return true;
};

export const checkValueOfKnn = knn => {
    if (Utils.isEmptyString(knn.value) || !Utils.isEmptyString(knn.error)) {
        return false;
    }
    return true;
};
export const checkValueOfMinScore = minScore => {
    if (Utils.isEmptyString(minScore.value) || !Utils.isEmptyString(minScore.error)) {
        return false;
    }
    return true;
};

export const checkValueOfChatGPTModel = chatGPT => {
    if (Utils.isEmptyString(chatGPT)) {
        return false;
    }
    return true;
};

const filterActiveBasicSetting = (conditions, obj) => {
    let isInternalQACounter = conditions.internalQACounterSettings.value;
    let isKnowledgeFunction = conditions.knowledgeFunction.group.knowledgeService.value;
    let isExternalServiceDesk =
        conditions.externalServiceDeskSettings.group.deskService.value;
    let activeObj = {}
    const keysToFilter = [
        'numberOfQACounters',
        'numberOfKnowledges',
        'numberOfSupportedCounters',
        'numberOfB2C'
    ];
    for (const key in obj) {
        if (!keysToFilter.includes(key)) {
            activeObj[key] = obj[key];
        }
    }
    if (!isInternalQACounter) {
        delete activeObj.numberOfQACounters;
    } else {
        activeObj.numberOfQACounters = {
            ...BASIC_SETTING.numberOfQACounters,
            value: obj.numberOfQACounters.value,
            error: obj.numberOfQACounters.error,
        };
    }

    if (!isKnowledgeFunction) {
        delete activeObj.numberOfKnowledges;
    } else {
        activeObj.numberOfKnowledges = {
            ...BASIC_SETTING.numberOfKnowledges,
            value: obj.numberOfKnowledges.value,
            error: obj.numberOfKnowledges.error,
        };
    }

    if (!isExternalServiceDesk) {
        delete activeObj.numberOfSupportedCounters;
        delete activeObj.numberOfB2C;
    } else {
        activeObj.numberOfSupportedCounters = {
            ...BASIC_SETTING.numberOfSupportedCounters,
            value: obj.numberOfSupportedCounters.value,
            error: obj.numberOfSupportedCounters.error,
        };
        activeObj.numberOfB2C = {
            ...BASIC_SETTING.numberOfB2C,
            value: obj.numberOfB2C.value,
            error: obj.numberOfB2C.error,
        };
    }

    return activeObj;
}

export const checkValueOfBasicSetting = (conditions, obj) => {
    const activeBasicSettingObj = filterActiveBasicSetting(conditions, obj);

    let isValid = Object.values(activeBasicSettingObj).every(option => {
        if (Utils.isEmptyString(option.value)) return false;
        if (!Utils.isEmptyString(option.error)) return false;
        return true;
    });

    Object.entries(obj).forEach((item) => {
        if (!Utils.isEmptyString(item[1]?.error)) {
            return isValid = false;
        }
    })

    return isValid;
};

export const checkValueOfAdvancedSetting = (advancedSetting) => {
    let isValid = true;

    Object.entries(advancedSetting).forEach((item) => {
        const quantityValue = item[1]?.quantity?.value?.trim();
        const priceValue = item[1]?.price?.value?.trim();

        if (
            !Utils.isEmptyString(item[1]?.price?.error) ||
            !Utils.isEmptyString(item[1]?.quantity?.error)
        ) {
            return (isValid = false);
        }

        if (quantityValue?.length > 0) {
            if (priceValue?.length === 0) {
                isValid = false;
                return; // Exit the loop immediately
            }
        } else {
            if (priceValue?.length > 0) {
                isValid = false;
                return; // Exit the loop immediately
            }
        }
    });

    return isValid;
};

const checkValueOfLincenseKey = (lincenseKey, functionSettingValue) => {
    let isValid = true;
    if(functionSettingValue.lincenseKeyPermission.value) {
        if(Utils.isEmptyString(lincenseKey.value) || !Utils.isEmptyString(lincenseKey.error)) return false;
    }
    return isValid;
}

export const handleRequiedField = (
    versionName,
    setVersionName,
    functionSettingValue,
    setFunctionSettingValue,
    basicSettingValue,
    setBasicSettingValue,
    advancedSettingValue,
    setAdvancedSettingValue,
    lincenseKey,
    setLincenseKey,
    basicPromptAI,
    defaultBasicAIPrompt
) => {
    const requiredMessage = I18n.get('COMMSG014');

    const checkSubmitdata = handleCheckSubmitData(
        versionName,
        functionSettingValue,
        basicSettingValue,
        advancedSettingValue,
        null,
        null, 
        null, 
        null, 
        null,
        null,
        lincenseKey,
        basicPromptAI,
        defaultBasicAIPrompt
    );
    if(!checkSubmitdata) {
        if(Utils.isEmptyString(versionName.value)) {
            setVersionName(prev => ({
                ...prev,
                error: requiredMessage
            }))
        }
        if(functionSettingValue.knowledgeFunction.group.lincenseKeyPermission.value) {
            if(Utils.isEmptyString(lincenseKey.value)) {
                setLincenseKey(prev => ({
                    ...prev,
                    error: requiredMessage
                }))
            }
        }
        const getActiveBasicSetting = filterActiveBasicSetting(
            functionSettingValue,
            basicSettingValue
        );
        Object.entries(getActiveBasicSetting).forEach((option) => {
            if (Utils.isEmptyString(option[1].value)) {
                setBasicSettingValue(prev => ({
                    ...prev,
                    [option[0]]: {
                        ...prev[option[0]],
                        error: requiredMessage
                    }
                }))
            }
        });
        Object.entries(advancedSettingValue).forEach((item) => {
            handleValidateAdvancedSettingOption(
                'quantity',
                item[1].quantity.value,
                'price',
                item[1].price.value,
                item[0],
                setAdvancedSettingValue,
                item[1].quantity?.error,
                item[1].price?.error
            )
        });
    }
};

export const handleCheckSubmitData = (
    versionName,
    functionSettingValue,
    basicSettingValue,
    advancedSettingValue,
    isEditVersion,
    defaultFunctionSettingValue, 
    defaultBasicSettingValue, 
    defaultAdvancedSettingValue, 
    defaultVersionNameValue,
    setIsEdit,
    lincenseKey,
    isChangeLincenseKey,
    basicAIPrompt,
    defaultBasicAIPrompt,
    isChangeSystemPrompt,
    knn,
    minScore,
    chatGPTModel,
    knnDefault,
    minScoreDefault,
    chatGPTModelDefault,
    systemPrompt,
    interatorSystemPrompt,
    isChangeInteratorSystemPrompt
) => {
    let isValidVersionName = checkValueOfVersionName(versionName);
    let isValidBasicSettingValue = checkValueOfBasicSetting(
        functionSettingValue,
        basicSettingValue
    );
    let isValidAdvancedSettingValue = checkValueOfAdvancedSetting(
        advancedSettingValue
    );
    let isValidLincenseKey = checkValueOfLincenseKey(lincenseKey, functionSettingValue);

    let isValidKnn = checkValueOfKnn(knn);
    let isValidMinScore = checkValueOfMinScore(minScore);
    let isValidChatGPTModel = checkValueOfChatGPTModel(chatGPTModel);
    let isValidSystemPrompt = !Utils.isEmptyString(systemPrompt?.error);
    let isValidInteratorSystemPrompt = !Utils.isEmptyString(interatorSystemPrompt?.error);

    let result = true;
    if (
        !isValidVersionName ||
        !isValidBasicSettingValue ||
        !isValidAdvancedSettingValue ||
        !isValidLincenseKey ||
        !isValidKnn ||
        !isValidMinScore ||
        !isValidChatGPTModel ||
        isValidSystemPrompt ||
        isValidInteratorSystemPrompt
    ) {
        result = false;
    }

    if (isEditVersion && result) {
        let isEditVersionName = _.isEqual(defaultVersionNameValue, versionName);
        let isEditFunctionSettingValue = _.isEqual(defaultFunctionSettingValue, functionSettingValue);
        let isEditBasicSettingValue = _.isEqual(defaultBasicSettingValue, basicSettingValue);
        let isEditAdvancedSettingValue = _.isEqual(defaultAdvancedSettingValue, advancedSettingValue);
        let isEditBasicPromptAi = basicAIPrompt?.id !== defaultBasicAIPrompt?.id
        let isEditKnn = _.isEqual(knnDefault, knn);
        let isEditMinScore = _.isEqual(minScoreDefault, minScore);
        let isEditChatGPTModel = _.isEqual(chatGPTModelDefault, chatGPTModel);
        
        if (
            isEditVersionName &&
            isEditFunctionSettingValue &&
            isEditBasicSettingValue &&
            isEditAdvancedSettingValue &&
            !isChangeLincenseKey &&
            !isChangeSystemPrompt &&
            !isEditBasicPromptAi &&
            !isChangeInteratorSystemPrompt &&
            isEditKnn &&
            isEditMinScore &&
            isEditChatGPTModel
        ) {
            result = false;
            if (setIsEdit) {
                setIsEdit(false);
            }
        }
    }

    return result;
};

export const handleSubmitFormVersion = async (
    API,
    isSubmit,
    versionName,
    setVersionName,
    functionSettingValue,
    setFunctionSettingValue,
    basicSettingValue,
    setBasicSettingValue,
    advancedSettingValue,
    setAdvancedSettingValue,
    setUsedFormButtonExpand,
    dataProduct,
    userId,
    setIsLoading,
    enqueueSnackbar,
    onBackEditionPanel,
    setOpenDropDownVersion,
    isEditVersion,
    setIsOpenModalReloadPage,
    setIsBackToProduct,
    setIsBackToEdition,
    isDuplicateVersion,
    lincenseKey,
    setLincenseKey,
    affiliationOrganization,
    isChangeLincenseKey,
    basicPromptAI,
    defaultBasicAIPrompt,

    systemPrompt,
    chatGPTModel,
    knn,
    minScore,
    setDefaultSystemPrompt,
    setChatGPTModelDefault,
    setKnnDefault,
    setMinScoreDefault,
    setSystemPrompt,
    setInputSystemPrompt,

    interatorSystemPrompt,
    setDefaultInteratorSystemPrompt,
    setInteratorSystemPrompt,
    setInputInteratorSystemPrompt
) => {
    if(!isSubmit) {
        //TODO: check field required
        handleRequiedField(
            versionName,
            setVersionName,
            functionSettingValue,
            setFunctionSettingValue,
            basicSettingValue,
            setBasicSettingValue,
            advancedSettingValue,
            setAdvancedSettingValue,
            lincenseKey,
            setLincenseKey,
            basicPromptAI,
            defaultBasicAIPrompt
        );
        setUsedFormButtonExpand(true)
        return;
    }
    setIsLoading(true);

    const moduleSetting = {
        internalQACounterSettings: functionSettingValue.internalQACounterSettings.value,
        deskService:
            functionSettingValue.externalServiceDeskSettings.group.deskService.value,
        publicWebForm: functionSettingValue.externalServiceDeskSettings.group.publicWebForm.value,
        emailResponseFunction: functionSettingValue.emailResponseFunction.value,
        knowledgeService:
            functionSettingValue.knowledgeFunction.group.knowledgeService.value,
        publicService: functionSettingValue.knowledgeFunction.group.publicService.value,
        knowledgeBot: functionSettingValue.knowledgeFunction.group.knowledgeBot.value,
        synonymSearch: functionSettingValue.knowledgeFunction.group.synonymSearch.value,
        convertPDF: functionSettingValue.knowledgeFunction.group.convertPDF.value,
        batchCommandService: functionSettingValue.knowledgeFunction.group.batchCommandService.value,
        chatAI: functionSettingValue.chatAI.value,
        lincenseKeyPermission: functionSettingValue.chatAI.value ? functionSettingValue.lincenseKeyPermission.value : false,
        chatGPTModel: chatGPTModel,
        knnValue: knn.value,
        minScore: minScore.value,
        aiAuto: functionSettingValue.chatAI.value ? functionSettingValue.aiAuto.value : false,
        systemPrompt: systemPrompt.linkPrompt,
        interatorSystemPrompt: interatorSystemPrompt.linkPrompt,
        taskManagement: functionSettingValue.taskManagement.value,
        advancedOptionSettings: functionSettingValue.advancedOptionSettings.value,
        logAnalysis: functionSettingValue.logAnalysis.value,
        ipRestriction: functionSettingValue.ipRestriction.value,

        numberOfTickets: Utils.removeExcessZeros(basicSettingValue.numberOfTickets.value),
        numberOfKnowledges: Utils.removeExcessZeros(basicSettingValue.numberOfKnowledges.value),
        numberOfFormat: Utils.removeExcessZeros(basicSettingValue.numberOfFormat.value),
        numberOfQACounters: Utils.removeExcessZeros(basicSettingValue.numberOfQACounters.value),
        numberOfSupportedCounters: Utils.removeExcessZeros(basicSettingValue.numberOfSupportedCounters.value),
        numberOfGeneralProjects: Utils.removeExcessZeros(basicSettingValue.numberOfGeneralProjects.value),
        numberOfInternalCustomers: Utils.removeExcessZeros(basicSettingValue.numberOfInternalCustomers.value),
        numberOfB2C: Utils.removeExcessZeros(basicSettingValue.numberOfB2C.value),
        storageVolume: Utils.removeExcessZeros(basicSettingValue.storageVolume.value),
        generalUserFee: Utils.removeExcessZeros(basicSettingValue.generalUserFee.value),
        basicCharge: Utils.removeExcessZeros(basicSettingValue.basicCharge.value),

        numberOfAdditionalTickets: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalTickets.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalTickets.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalKnowledge: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalKnowledge.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalKnowledge.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalStorages: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalStorages.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalStorages.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalQACounter: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalQACounter.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalQACounter.price.value),
            unitPrice: 'JPY'
        },
        numberOfAdditionalSupportedCounter: {
            value: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalSupportedCounter.quantity.value),
            price: Utils.removeExcessZeros(advancedSettingValue.numberOfAdditionalSupportedCounter.price.value),
            unitPrice: 'JPY'
        },
    };
    let type = ProductManagementConstant.CREATE_VERSION;
    let versionId = '';
    if (isEditVersion) {
        type = ProductManagementConstant.METHOD_PRODUCT.UPDATE_VERSION;
        versionId = dataProduct.versionId;
    }
    if (isDuplicateVersion) {
        type = ProductManagementConstant.METHOD_PRODUCT.COPY_VERSION;
        versionId = dataProduct.versionId;
    }
    let lincenseKeySetting = {
        key: lincenseKey.value,
        affiliationOrganization: affiliationOrganization
    };

    if (!functionSettingValue.chatAI.value) {
        lincenseKeySetting.key = '';
    }

    if (lincenseKey.value == Constant.NOT_ROOT_SETTING_KEY) {
        lincenseKeySetting = null;
    }
    let requestBody = {
        type: type,
        productId: dataProduct?.productId,
        editionId: dataProduct?.editionId,
        versionName: versionName.value,
        moduleSetting: moduleSetting,
        userId: userId,
        versionId: versionId,
        lincenseKeySetting: lincenseKeySetting ? JSON.stringify(lincenseKeySetting) : null,
        basicPromptAI: Utils.isEmptyString(basicPromptAI?.id) ? 'none' : basicPromptAI.id
    };

    let res = await updateProductManagement(API, requestBody);

    if (!res || !res?.status) {
        // todo show error message
        setIsLoading(false);
        switch (res.errorMessage) {
            case "MSG-CM-DATA-DUPLICATION":
                setVersionName(prevState => ({
                    ...prevState,
                    error: I18n.get('MSG-CM-VERSION-DATA-DUPLICATION')
                }));
                return;
            case "isNotProductExist":
                setIsBackToProduct(true)
                setIsOpenModalReloadPage(true);
                return;
            case "isNotEditionExist":
                setIsBackToEdition(true)
                setIsOpenModalReloadPage(true);
                return;
            case 'MSG_AI_LICENSE_KEY_INVALID':
                setLincenseKey(prev => ({
                    ...prev,
                    error: I18n.get('MSG-AI-LICENSE-KEY-INVALID')
                }));
                return;
            case 'MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN':
                setSystemPrompt(prev => ({
                    ...prev,
                    error: I18n.get('MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN')
                }));
                setInputSystemPrompt(systemPrompt?.linkPrompt);
                return;
            case 'MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN-INTERATOR':
                setInteratorSystemPrompt(prev => ({
                    ...prev,
                    error: I18n.get('MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN-INTERATOR')
                }));
                setInputInteratorSystemPrompt(interatorSystemPrompt?.linkPrompt);
                return;
            default:
                enqueueSnackbar(I18n.get('SYSMSG001'), {
                    variant: 'error',
                    autoHideDuration: 3000
                });
                return;
        }
    }
    setDefaultSystemPrompt(systemPrompt);
    setDefaultInteratorSystemPrompt(interatorSystemPrompt);
    setChatGPTModelDefault(chatGPTModel)
    setKnnDefault(knn);
    setMinScoreDefault(minScore);
    setIsLoading(false);
    if (isEditVersion) {
        enqueueSnackbar(I18n.get('MSG-CM-UPDATE-DATA-SUCCESS').replace('{{data_type}}', 'バージョン'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    } else {
        enqueueSnackbar(I18n.get('MSG-CM-SAVE-DATA-SUCCESS').replace('{{data_type}}', 'バージョン'), {
            variant: 'success',
            autoHideDuration: 3000
        });
    }

    let editionData = {
        id: dataProduct?.productId,
        productId: dataProduct?.productId,
        name: dataProduct?.nameProduct
    }

    setOpenDropDownVersion(prevState => {
        let index = Utils.findIndexInArrayById(dataProduct.editionId, prevState);
        if(index !== -1) {
            prevState[index].open = true;
        }
        return prevState;
    })

    onBackEditionPanel(editionData, ProductManagementConstant.EDITION_LIST)
};

export const callBackReloadPage = (onBackEditionPanel, isBackToProduct, isBackToEdition, dataProduct, setOpenDropDownVersion) => {
    if (isBackToProduct) {
        onBackEditionPanel(
            {},
            ProductManagementConstant.PRODUCT_LIST
        );
    }

    if (isBackToEdition) {
        let editionData = {
            id: dataProduct?.productId,
            productId: dataProduct?.productId,
            name: dataProduct?.nameProduct
        }
    
        setOpenDropDownVersion(prevState => {
            let index = Utils.findIndexInArrayById(dataProduct.editionId, prevState);
            if(index !== -1) {
                prevState[index].open = true;
            }
            return prevState;
        })
    
        onBackEditionPanel(editionData, ProductManagementConstant.EDITION_LIST);
    }
}

export const onClickNoCanCelOrClosePanel = (
    dataProduct,
    onBackEditionPanel,
    setIsClosePanelVersion
) => {
    let editionData = {
        id: dataProduct?.productId,
        productId: dataProduct?.productId,
        name: dataProduct?.nameProduct
    };
    onBackEditionPanel(editionData, ProductManagementConstant.EDITION_LIST);
    setIsClosePanelVersion({
        isClose: false,
        componentType: ProductManagementConstant.EDITION_LIST
    });
};

export const onYesCanCelOrClosePanel = async (
    API,
    setIsClosePanelVersion,
    isSubmit,
    functionSettingValue,
    setFunctionSettingValue,
    basicSettingValue,
    setBasicSettingValue,
    advancedSettingValue,
    setAdvancedSettingValue,
    setUsedFormButtonExpand,
    dataProduct,
    versionName,
    userId,
    setIsLoading,
    enqueueSnackbar,
    onBackEditionPanel,
    setIsShowPopUpCancel,
    setOpenDropDownVersion,
    setVersionName,
    isEditVersion,
    setIsOpenModalReloadPage,
    setIsBackToProduct,
    setIsBackToEdition,
    isDuplicateVersion,
    lincenseKey,
    setLincenseKey,
    basicAIPrompt,
    defaultBasicAIPrompt,
    affiliationOrganization,
    isChangeLincenseKey,

    systemPrompt,
    chatGPTModel,
    knn,
    minScore,
    setDefaultSystemPrompt,
    setChatGPTModelDefault,
    setKnnDefault,
    setMinScoreDefault,
    setSystemPrompt,
    setInputSystemPrompt,

    interatorSystemPrompt,
    setDefaultInteratorSystemPrompt,
    setInteratorSystemPrompt,
    setInputInteratorSystemPrompt
) => {
    setIsShowPopUpCancel(false);
    setIsClosePanelVersion({
        isClose: false,
        componentType: ProductManagementConstant.EDITION_LIST
    });
    await handleSubmitFormVersion(
        API,
        isSubmit,
        versionName,
        setVersionName,
        functionSettingValue,
        setFunctionSettingValue,
        basicSettingValue,
        setBasicSettingValue,
        advancedSettingValue,
        setAdvancedSettingValue,
        setUsedFormButtonExpand,
        dataProduct,
        userId,
        setIsLoading,
        enqueueSnackbar,
        onBackEditionPanel,
        setOpenDropDownVersion,
        isEditVersion,
        setIsOpenModalReloadPage,
        setIsBackToProduct,
        setIsBackToEdition,
        isDuplicateVersion,
        lincenseKey,
        setLincenseKey,
        affiliationOrganization,
        isChangeLincenseKey,
        basicAIPrompt,
        defaultBasicAIPrompt,
        systemPrompt,
        chatGPTModel,
        knn,
        minScore,
        setDefaultSystemPrompt,
        setChatGPTModelDefault,
        setKnnDefault,
        setMinScoreDefault,
        setSystemPrompt,
        setInputSystemPrompt,

        interatorSystemPrompt,
        setDefaultInteratorSystemPrompt,
        setInteratorSystemPrompt,
        setInputInteratorSystemPrompt
    );
};

export const onClickCancelVersion = (setIsShowPopUpCancel, isEdit, onBackEditionPanel, dataProduct) => {
    if(isEdit) {
        setIsShowPopUpCancel(true);
        return;
    }
    let editionData = {
        id: dataProduct?.productId,
        productId: dataProduct?.productId,
        name: dataProduct?.nameProduct
    };
    
    return onBackEditionPanel(editionData, ProductManagementConstant.EDITION_LIST);
}

export const getVersionDataById = async (
    API,
    versionId,
    setIsLoading,
    setVersionName,
    setFunctionSettingValue,
    setBasicSettingValue,
    setAdvancedSettingValue,
    setDefaultFunctionSettingValue,
    setDefaultBasicSettingValue,
    setDefaultAdvancedSettingValue,
    setDefaultVersionNameValue,
    isDuplicateVersion,
    setIsOpenModalReloadPage,
    setIsBackToProduct,
    setIsBackToEdition,
    editionId,
    productId,
    setBasicAIPrompt,
    setDefaultBasicAIPrompt,
    setSystemPrompt,
    setDefaultSystemPrompt,

    setChatGPTModel,
    setKnn,
    setMinScore,
    setChatGPTModelDefault,
    setKnnDefault,
    setMinScoreDefault,
    chatGPTModelDefault,
    knnDefault,
    minScoreDefault,
    setInputSystemPrompt,

    setInteratorSystemPrompt,
    setDefaultInteratorSystemPrompt,
    setInputInteratorSystemPrompt
) => {
    if (!versionId) {
        return;
    }
    setIsLoading(true);
    let requestBody = {
        type: ProductManagementConstant.METHOD_PRODUCT.GET_VERSION_BY_ID,
        versionId: versionId,
        editionId: editionId,
        productId: productId
    };

    let res = await getProductById(API, requestBody);
    if (!res || !res.status) {
        setIsLoading(false);
        if(res?.errorMessage === "isNotProductExist") {
            setIsBackToProduct(true)
            setIsOpenModalReloadPage(true);
        }
        if(res?.errorMessage === "isNotEditionExist" || res?.errorMessage === "isNotVersionExist") {
            setIsBackToEdition(true)
            setIsOpenModalReloadPage(true);
        }
        return;
    }
    let versionData = Utils.convertJSONDataToObject(res.versionDetail);
    setBasicAIPrompt(!Utils.isEmptyObject(versionData.basicPromptAI) ? versionData.basicPromptAI: {});
    setDefaultBasicAIPrompt(!Utils.isEmptyObject(versionData.basicPromptAI) ? versionData.basicPromptAI: {});
    let versionName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, versionData.name);
    let errorVersionName = ''
    if (isDuplicateVersion) {
        versionName+=' - Copy';
        errorVersionName = versionName.length > 200 ? I18n.get('COMMSG022').replace('{{maxLength}}', '200') : '';
    }
    setVersionName({
        value: versionName,
        error: errorVersionName
    });

    let moduleSetting = versionData.moduleSetting;
    let defaultFunctionSettingValue = {
        internalQACounterSettings: {
            value: moduleSetting.internalQACounterSettings || false 
        },
        externalServiceDeskSettings: {
            group: {
                deskService: {
                    value: moduleSetting.deskService || false
                },
                publicWebForm: {
                    value: moduleSetting.publicWebForm || false
                }
            }
        },
        emailResponseFunction: {
            value: moduleSetting.emailResponseFunction || false
        },
        knowledgeFunction: {
            group: {
                knowledgeService: {
                    value: moduleSetting.knowledgeService || false
                },
                publicService: {
                    value: moduleSetting.publicService || false
                },
                knowledgeBot: {
                    value: moduleSetting.knowledgeBot || false
                },
                convertPDF: {
                    value: moduleSetting.convertPDF || false
                },
                synonymSearch: {
                    value: moduleSetting.synonymSearch || false
                },
                batchCommandService: {
                    value: moduleSetting?.batchCommandService || false
                }
            }
        },
        chatAI: {
            value: moduleSetting.chatAI || false
        },
        lincenseKeyPermission: {
            value: moduleSetting.lincenseKeyPermission || false
        },
        aiAuto: {
            value: moduleSetting?.aiAuto || false
        },
        taskManagement: {
            value: moduleSetting.taskManagement || false
        },
        advancedOptionSettings: {
            value: moduleSetting.advancedOptionSettings || false
        },
        logAnalysis: {
            value: moduleSetting.logAnalysis || false
        },
        ipRestriction: {
            value: moduleSetting?.ipRestriction || false
        }
    };
    let defaultBasicSettingValue = {};
    let defaultAdvancedSettingValue = {};

    Object.keys(BASIC_SETTING).forEach(field => {
        defaultBasicSettingValue[field] = {
            type: BASIC_SETTING[field].type,
            value: moduleSetting[field],
            unit: BASIC_SETTING[field].unit,
            error: '',
            rules: BASIC_SETTING[field].rules
        };
    });

    Object.keys(ADVANCED_SETTING).forEach(field => {
        defaultAdvancedSettingValue[field] = {};

        Object.entries(ADVANCED_SETTING[field]).forEach(subField => {
            const [key, attrs] = subField
            defaultAdvancedSettingValue[field][key] = {
                        type: ADVANCED_SETTING[field][key].type,
                        value: key === 'quantity' ? moduleSetting[field].value : 'price' ? moduleSetting[field].price : '',
                        error: '',
                        rules: ADVANCED_SETTING[field][key].rules
            };
        });
    });

    setFunctionSettingValue(defaultFunctionSettingValue);
    setBasicSettingValue(defaultBasicSettingValue);
    setAdvancedSettingValue(defaultAdvancedSettingValue);

    setDefaultFunctionSettingValue(defaultFunctionSettingValue);
    setDefaultBasicSettingValue(defaultBasicSettingValue);
    setDefaultAdvancedSettingValue(defaultAdvancedSettingValue);
    setDefaultVersionNameValue({
        value: versionName,
        error: errorVersionName
    })
    if (moduleSetting?.systemPrompt) {
        const systemPromptTemp = {
            value: moduleSetting?.systemPrompt?.value || '',
            error: moduleSetting?.systemPrompt?.error || "",
            linkPrompt: moduleSetting?.systemPrompt?.linkPrompt || ''
        }

        const systemPromptId = await Utils.getTicketIdByShareLink(moduleSetting?.systemPrompt?.linkPrompt);
        const ticketDetail = await getTicketById(null, systemPromptId)
        const formStatusOfTicket = Utils.convertJSONDataToObject(ticketDetail?.formId)
        if (
            (!Utils.isEmptyString(ticketDetail?.deletedAt) ||
                !formStatusOfTicket?.active ||
                ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT ||
                ticketDetail?.promptFlag !== Constant.ACTIVE_FLAG.ACTIVE) &&
            !Utils.isEmptyObject(ticketDetail)
        ) {
            setInputSystemPrompt( moduleSetting?.systemPrompt?.linkPrompt )
            systemPromptTemp.error = I18n.get('MSG-CM-INVALID-LINK-PROMPT');
            systemPromptTemp.value = ''
        }
        setInputSystemPrompt( moduleSetting?.systemPrompt?.linkPrompt || "")
        setSystemPrompt(prev => ({
            ...prev,
            ...systemPromptTemp
        }));
        setDefaultSystemPrompt(prev => ({
            ...prev,
            ...systemPromptTemp,
        }));
    }

    if (moduleSetting?.interatorSystemPrompt) {
        const interatorPromptTemp = {
            value: moduleSetting?.interatorSystemPrompt?.value || '',
            error: moduleSetting?.interatorSystemPrompt?.error || '',
            linkPrompt: moduleSetting?.interatorSystemPrompt?.linkPrompt || ''
        };

        const interatorSystemPromptId = moduleSetting?.interatorSystemPrompt?.linkPrompt
            ?.split('/')
            .pop();
        const ticketDetail = await getTicketById(null, interatorSystemPromptId);
        const formStatusOfTicket = Utils.convertJSONDataToObject(ticketDetail?.formId);
        if (
            (!Utils.isEmptyString(ticketDetail?.deletedAt) ||
                !formStatusOfTicket?.active ||
                ticketDetail?.public === Constant.TICKET_PUBLIC.DRAFT ||
                ticketDetail?.promptFlag !== Constant.ACTIVE_FLAG.ACTIVE) &&
            !Utils.isEmptyObject(ticketDetail)
        ) {
            setInputInteratorSystemPrompt(moduleSetting?.interatorSystemPrompt?.linkPrompt);
            interatorPromptTemp.error = I18n.get('MSG-CM-INVALID-LINK-PROMPT');
            interatorPromptTemp.value = '';
        }
        setInputInteratorSystemPrompt(moduleSetting?.interatorSystemPrompt?.linkPrompt || '');
        setInteratorSystemPrompt(prev => ({
            ...prev,
            ...interatorPromptTemp
        }));
        setDefaultInteratorSystemPrompt(prev => ({
            ...prev,
            ...interatorPromptTemp
        }));
    }

    setChatGPTModel(moduleSetting.chatGPTModel || Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
    setKnn({
        value: moduleSetting?.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE,
        error: ''
    })
    setMinScore({
        value: moduleSetting?.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE,
        error: ''
    })
    
    setChatGPTModelDefault(moduleSetting.chatGPTModel || Constant.SETTING_AI_DEFAULT.CHATGPT_MODEL_ID);
    setKnnDefault({
        value: moduleSetting?.knnValue || Constant.SETTING_AI_DEFAULT.KNN_VALUE,
        error: ''
    })
    setMinScoreDefault({
        value: moduleSetting?.minScore || Constant.SETTING_AI_DEFAULT.MIN_SCORE,
        error: ''
    })

    setIsLoading(false);
    return;
};

export const validateTextField = (rules, inputValue, key) => {

    if (!Array.isArray(rules)) return '';
    const hasIsRequire = rules.some(rule => rule.name === 'isRequire');
    if (Utils.isEmptyString(inputValue) && hasIsRequire && ['knn', 'minScore'].includes(key)) 
        return I18n.get('MSG-CM-REQUIRED-INPUT');
    let errorMessage = '';

    const validate = rules.some((rule) => {
        const regexNumber = /^\d+$/;
        const regexDecimal = /^[0-9]+(\.[0-9]+)?$/;

        switch (rule.name) {
            case 'isNumber':
                if (!regexNumber.test(inputValue)) {
                    if(key === 'numberOfTickets') {
                        errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', 1);
                        return true;
                    } else if (key === 'knn') {
                        errorMessage = I18n.get('MSG-AI-INVALID-K-VALUE');
                        return true;
                    } else {
                        errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', 0);
                        return true;
                    }
                }
                if(key === 'knn' && inputValue.startsWith('0')) {
                    errorMessage = I18n.get('MSG-AI-INVALID-K-VALUE');
                    return true;
                }
                break;

            case 'isDecimal':
                if (key === 'minScore') {
                    if (!regexDecimal.test(inputValue)) {
                        errorMessage = I18n.get('MSG-AI-INVALID-MIN-SCORE-VALUE');
                        return true;
                    }
                    if(inputValue.startsWith('0') && !inputValue.includes('.') && inputValue !== '0') {
                        errorMessage = I18n.get('MSG-AI-INVALID-MIN-SCORE-VALUE');
                        return true;
                    }
                    return true;
                }
                if (!regexDecimal.test(inputValue)) {
                    errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-DOT-FORMAT');
                    return true;
                }
                if(inputValue.startsWith('0') && !inputValue.includes('.')) {
                    errorMessage = I18n.get('MSG-CM-STORAGE-ERROR');
                    return true;
                }
                if(Utils.removeExcessZeros(inputValue) === "0") {
                    errorMessage = I18n.get('MSG-CM-STORAGE-ERROR');
                    return true;
                }
                const [integerPart, decimalPart] = inputValue.split('.');
                if (
                    (!Utils.isEmptyString(integerPart) && integerPart.length > 4) ||
                    (!Utils.isEmptyString(decimalPart) && decimalPart.length > 3)
                ) {
                    errorMessage = I18n.get('MSG-CM-STORAGE-ERROR');
                    return true;
                }
                break;

            case 'maxLength':
                if (inputValue.length > rule.value) {
                    if (Utils.isNumber(inputValue)) {
                        errorMessage = I18n.get('COMMSG022').replace('{{maxLength}}', rule.value);
                        return true;
                    }
                    errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', 1);
                    return true;
                }
                break;
            case 'minValue':
                if (inputValue < rule.value) {
                    if (key === 'knn') {
                        errorMessage = I18n.get('MSG-AI-INVALID-K-VALUE');
                    } else if (key === 'minScore') {
                        errorMessage = I18n.get('MSG-AI-INVALID-MIN-SCORE-VALUE');
                    } else {
                        errorMessage = I18n.get('MSG-CM-WRONG-NUMBER-FORMAT').replace('{{min_value}}', rule.value);
                    }
                    return true;
                }
                break;
            case 'maxValue':
                if (inputValue > rule.value) {
                    if (key === 'knn') {
                        errorMessage = I18n.get('MSG-AI-INVALID-K-VALUE');
                    }
                    if (key === 'minScore') {
                        errorMessage = I18n.get('MSG-AI-INVALID-MIN-SCORE-VALUE');
                    }
                    return true;
                }
                break;
            default:
                errorMessage = ``;
                return false;
        }

        //default value
        return false;
    });
    
    if(validate) {
        return errorMessage 
    }else {
        return '' ;
    }
};


export const getProductLicenseKeySetting = async (
    API,
    productId,
    affiliationOrganization,
    setLincenseKey,
    setIsRootSetting,
    setIsLoading,
    setLicenseKeyDefault
) => {
    if (!productId) {
        return;
    }
    setIsLoading(true);

    let requestBody = {
        type: ProductManagementConstant.METHOD_PRODUCT.GET_PRODUCT_BY_ID,
        affiliationOrganization: affiliationOrganization,
        productId: productId
    };
    let product = await getDetailByProductId(API, requestBody);

    if (product?.moduleSetting) {
        let moduleSetting = Utils.convertJSONDataToObject(product.moduleSetting);
        setLincenseKey(prev => ({
            ...prev,
            value: moduleSetting.lincenseKeySetting.key
        }));
        setLicenseKeyDefault(moduleSetting.lincenseKeySetting.key);

        if (affiliationOrganization !== moduleSetting.lincenseKeySetting.affiliationOrganization) {
            setIsRootSetting(false);
        }
    }

    setIsLoading(false);
    return;
};

export const handleOnBlurSystemPromptSetting = async (
    e,
    API,
    setIsLoading,
    systemPrompt,
    setSystemPrompt,
    setIsEdit,
    setIsChangeSystemPrompt
) => {
    if (Utils.isEmptyString(e.target.value)) {
        if (!Utils.isEmptyString(systemPrompt)) {
            setIsChangeSystemPrompt(true);
        }
        setSystemPrompt(prev => ({
            ...prev,
            value: '',
            linkPrompt: '',
            error: ''
        }))
        return;
    }
    const invalidLinkMessage = I18n.get('MSG-AI-PASTED-LINK-ARE-NOT-PROMPT-KNOWN');

    if (!Utils.isValidLinkPromptInput(e.target.value)) {
        setSystemPrompt(prev => ({
            ...prev,
            error: invalidLinkMessage
        }))
        return;
    }
    setIsLoading(true);
    let linkSystemPrompt = e.target.value;
    const idTicket = await Utils.getTicketIdByShareLink(linkSystemPrompt);

    let paramsGetTitleTicketPrompt = {
        getApiType: Constant.GET_API_PUBLIC_TYPE.GET_TITLE_OF_TICKET_PROMPT,
        ticketId: idTicket
    };

    let ticketTitleData = await getPublicAPI(API, paramsGetTitleTicketPrompt);
    if (Utils.isEmptyObject(ticketTitleData)) {
        setSystemPrompt(prev => ({
            ...prev,
            error: invalidLinkMessage
        }))
        setIsLoading(false);
        return;
    }
    if (!ticketTitleData.success) {
        setSystemPrompt(prev => ({
            ...prev,
            error: invalidLinkMessage
        }))
        setIsLoading(false);
        return;
    }
    let payload = Utils.convertJSONDataToObject(ticketTitleData.payload);
    setSystemPrompt(prev => ({
        ...prev,
        value: payload.titleTicket,
        error: '',
        linkPrompt: linkSystemPrompt
    }))
    setIsLoading(false);

    setIsEdit(true);
    setIsChangeSystemPrompt(true);
};
